// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a4396e52","50":"9813f6fa","136":"2fe4eff6","139":"3a1aa61f","245":"c00aa2b7","331":"7d1fedff","391":"21f9411a","418":"24cb6324","469":"d0e6fd6e","672":"30a6769d","843":"952d8a7e","907":"1ce5a6b3","914":"231de2df","950":"a0e3d0b2"}[chunkId] + ".chunk.js";
};